import { Checkbox } from '@design-system/components/checkbox/checkbox';
import { Typography } from '@design-system/components/typography/typography';
import { sectionWrapper, pricesWrapper } from './SubscriptionPriceSetup.css';
import { InputPrice } from '@design-system/components/input/inputPrice';
import { faDollar } from '@fortawesome/pro-regular-svg-icons';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';
import { Controller } from 'react-hook-form';

export type SubscriptionPriceSetupProps = Pick<
  SubscriptionBundlesVM['priceEditModal'],
  'control' | 'freeTrial' | 'transformPrice'
>;

export const SubscriptionPriceSetup = ({
  control,
  freeTrial,
  transformPrice,
}: SubscriptionPriceSetupProps) => {
  return (
    <div className={pricesWrapper}>
      <div className={clsx(sectionWrapper)}>
        <div className="flex flex-col gap-2">
          <Controller
            name="monthlyPriceEnabled"
            control={control}
            render={({ field: { onChange, value } }) => (
              <div className="flex items-center">
                <Checkbox
                  checked={value as boolean}
                  onChange={onChange}
                  wrapperClassName="p-4"
                  checkboxVariant="neutral"
                  testId="monthly-price-checkbox"
                />
                <Typography>Price per month</Typography>
              </div>
            )}
          />
          <div className="w-[200px] pl-[44px]">
            <Controller
              name="monthlyPrice"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <InputPrice
                  value={value as string}
                  onChange={onChange}
                  startIcon={{
                    icon: faDollar,
                    className: sprinkles({ color: 'N-80' }),
                  }}
                  supportingText="Min. value $1.00"
                  placeholder="00.00"
                  hasError={!!error}
                  disabled={freeTrial.disabled.monthly}
                  onBlur={() => {
                    value && transformPrice(value, 'monthlyPrice');
                  }}
                  testId="monthly-price-input"
                />
              )}
            />
          </div>
        </div>
      </div>
      <div className={clsx(sectionWrapper)}>
        <div className="flex flex-col gap-2">
          <Controller
            name="annualPriceEnabled"
            control={control}
            render={({ field: { onChange, value } }) => (
              <div className="flex items-center">
                <Checkbox
                  checked={value as boolean}
                  onChange={onChange}
                  wrapperClassName="p-4"
                  checkboxVariant="neutral"
                  testId="annual-price-checkbox"
                />
                <Typography>Price per year</Typography>
              </div>
            )}
          />
          <div className="w-[200px] pl-[44px]">
            <Controller
              name="annualPrice"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <InputPrice
                  value={value as string}
                  onChange={onChange}
                  startIcon={{
                    icon: faDollar,
                    className: sprinkles({ color: 'N-80' }),
                  }}
                  supportingText="Min. value $10.00"
                  placeholder="00.00"
                  hasError={!!error}
                  disabled={freeTrial.disabled.annual}
                  onBlur={() => {
                    value && transformPrice(value, 'annualPrice');
                  }}
                  testId="annual-price-input"
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
